/**
 * PCM Website Viewer
 *
 * Opens a portfolio card's full-page screenshot ([data-website-viewer], see
 * partials/website-cards.php) in the #pcmWebsiteViewer modal. The image fills
 * the modal's width and scrolls inside it, so every site shows at the same
 * size however tall its page is, and the modal is the same width for every
 * site (1140px, or the full screen on phones). The srcset lets the browser
 * pick the copy of the screenshot that suits that width.
 *
 * Previous/next (buttons and arrow keys) move through the cards sharing the
 * clicked card's data-website-group. Without JS or Bootstrap the card is a
 * plain link to the screenshot.
 */
(function() {
  'use strict';

  var BLANK = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';

  var modalEl = document.getElementById('pcmWebsiteViewer');
  if (!modalEl) {
    return;
  }

  var body = modalEl.querySelector('.website-viewer__body');
  var img = modalEl.querySelector('.website-viewer__img');
  var title = modalEl.querySelector('.website-viewer__title');
  var live = modalEl.querySelector('.website-viewer__live');
  var navButtons = modalEl.querySelectorAll('[data-website-viewer-step]');

  var cards = [];
  var index = 0;
  var trigger = null;

  function show() {
    var data = cards[index].dataset;
    body.classList.add('is-loading');
    img.removeAttribute('srcset');
    img.src = BLANK;
    if (data.width && data.height) {
      img.width = parseInt(data.width, 10);
      img.height = parseInt(data.height, 10);
    }
    img.sizes = '(min-width: 1200px) 1140px, (min-width: 768px) calc(100vw - 3rem), 100vw';
    if (data.srcset) {
      img.srcset = data.srcset;
    }
    img.src = data.src;
    img.alt = 'Full-page screenshot of the ' + data.name + ' website';
    title.textContent = data.name;

    if (data.liveUrl) {
      live.href = data.liveUrl;
      live.hidden = false;
    } else {
      live.removeAttribute('href');
      live.hidden = true;
    }

    navButtons.forEach(function(button) {
      var step = parseInt(button.getAttribute('data-website-viewer-step'), 10);
      button.hidden = cards.length < 2;
      button.disabled = index + step < 0 || index + step >= cards.length;
    });

    body.scrollTop = 0;
  }

  function step(delta) {
    var next = index + delta;
    if (next < 0 || next >= cards.length) {
      return;
    }
    index = next;
    show();
  }

  img.addEventListener('load', function() {
    if (img.src !== BLANK) {
      body.classList.remove('is-loading');
    }
  });

  document.addEventListener('click', function(event) {
    var card = event.target.closest('[data-website-viewer]');
    if (!card || !window.bootstrap || !window.bootstrap.Modal) {
      return;
    }

    event.preventDefault();
    trigger = card;

    var group = card.getAttribute('data-website-group');
    cards = Array.prototype.filter.call(document.querySelectorAll('[data-website-viewer]'), function(el) {
      return el.getAttribute('data-website-group') === group;
    });
    index = Math.max(0, cards.indexOf(card));

    show();
    window.bootstrap.Modal.getOrCreateInstance(modalEl).show();
  });

  navButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      step(parseInt(button.getAttribute('data-website-viewer-step'), 10));
    });
  });

  modalEl.addEventListener('keydown', function(event) {
    if (event.key === 'ArrowLeft') {
      step(-1);
    } else if (event.key === 'ArrowRight') {
      step(1);
    }
  });

  modalEl.addEventListener('hidden.bs.modal', function() {
    img.removeAttribute('srcset');
    img.src = BLANK;
    // Back to the card that was showing last, so keyboard users land where they left off.
    var last = cards[index] || trigger;
    if (last) {
      last.focus();
    }
  });
})();
